import * as React from 'react';
import { InputOption } from "../classes/index";

export interface CheckboxProps {
    id: string;
    onChange?: (newValue: boolean) => void;
    properties: InputOption;
    /**
     * If this is true, look at the component containing this view to see how the check logic is running.
     */
    isCheckedOverrideValue?: boolean;
}

const checkbox: React.SFC<CheckboxProps> = (props) => {

    const onChangeFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log("checked");
        props.onChange(e.currentTarget.checked);
    }

    const checkboxName = `${props.id}-checkbox-js`;
    return (
        <div className="cal-ada-option">
            <input type="checkbox" id={checkboxName} onChange={onChangeFunc.bind(this)} checked={props.isCheckedOverrideValue}></input>
            <label htmlFor={checkboxName}>
                {props.children}
            </label>
        </div>
    );
}

export default checkbox;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/checkbox.tsx